var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 16,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7V5a3 3 0 0 1 6 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12h16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockCircleIcon);
export default __webpack_public_path__ + "static/media/lock_circle_icon.6f6df37381b366f0bb9d457f110b798d.svg";
export { ForwardRef as ReactComponent };